import { SupportingDocumentType } from './SupportingDocumentType';

export const notMissingInfoCategory: SupportingDocumentType[] = [
    SupportingDocumentType.PAYMENT_LETTER,
    SupportingDocumentType.OTHER,
];
export type MissingInfoCategory = Exclude<SupportingDocumentType, (typeof notMissingInfoCategory)[number]>;
